import { AxiosResponse } from 'axios';
import Context from '../../context';
import { Objeto } from '../../Models';

class NFSe {
    /* #region  GET Controller  */
    /* Sobre esta função *//**
     * Lista as notas fiscais geradas por uma empresa específica
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     **/
    public async ConsultarPorEmpresa(Token: string, Empresa: number): Promise<AxiosResponse<any>> {
        return await Context.get<{Token: string, Pessoa: any}>(`/NFSe/ConsultarPorEmpresa/${Token}/${Empresa}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* Sobre esta função *//**
     * Lista as notas fiscais geradas por uma empresa e centro de custo específico
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe a sigla que identifica o centro de custo. A lista dos centros de custos cadastrados poderá ser obtido ao executar a requisição "/CentroDeCusto/{Token}/{Empresa}"
     **/
    public async ConsultarPorCentroDeCusto(Token: string, Empresa: number, CentroDeCusto: string): Promise<AxiosResponse<any>> {
        return await Context.get<{Token: string, Pessoa: any}>(`/NFSe/ConsultarPorCentroDeCusto/${Token}/${Empresa}/${CentroDeCusto}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  POST Controller  */
    /* Sobre esta função *//**
     * Gerar nota(s) fiscal(is)
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {Array<Objeto.NFSe>} NFS Informe as notas fiscais a serem geradas
     **/
    public async Post(Token: string, NFS: Array<Objeto.NFSe>): Promise<AxiosResponse<Array<Objeto.NFSe>>> {
        return await Context.post<any>(`/NFSe/${Token}`, NFS)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* Sobre esta função *//**
     * Cadastra um novo usuário
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe a sigla que identifica o centro de custo. A lista dos centros de custos cadastrados poderá ser obtido ao executar a requisição "/CentroDeCusto/{Token}/{Empresa}"
     * @param { Nome: string, Conteudo: File | null | undefined } Arquivo Insira um objeto com todos os dados da arquivo
     **/
    public async ImportarPlanilha(Token: string, Empresa: number, CentroDeCusto: string, Arquivo: { Nome: string, Conteudo: File | null | undefined }): Promise<AxiosResponse<{pdf: string, tabelaOrignal: Array<any>, nfs: Array<Objeto.NFSe> }>> {
        let File = new FormData();
        File.append("Arquivo", new Blob([Arquivo.Conteudo || {} as File], { type: Arquivo.Conteudo?.type }), Arquivo.Nome);
        return await Context.post<any>(`/NFSe/ImportarPlanilha/${Token}/${Empresa}/${CentroDeCusto}`, File, { headers: { "content-type": "multipart/form-data" } })
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  PUT Controller  */
    /* #endregion */
};

export default new NFSe();